import { Component, ElementRef, Injector, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { ContratoService } from 'administrativo-lib';
import {
  BaseResourceFormComponent, Contrato, DateFormatPipe, EddyAutoComplete, EmpenhoExtra, EmpenhoExtraDeducaoReinf, EmpenhoExtraIsencaoReinf, Exercicio, Favorecido, FavorecidoService, FichaExtra,
  FuncaoService, GlobalService, LoginContabil, OrgaoAssinaturaService, RetencaoExtra, Tabela1Reinf
} from 'eddydata-lib';
import { ConfirmationService, MessageService } from 'primeng/api';
import { takeUntil } from 'rxjs/operators';
import { warning } from 'toastr';
import { FichaExtraService } from '../../ficha-extra/service/ficha-extra.service';
import { NotaEmpenhoExtra } from '../../relatorio/contabil/nota-empenho-extra';
import { EmpenhoExtraService } from '../service/empenho-extra.service';
import { RetencaoExtraService } from '../service/retencao-extra.service';

declare var $: any;

@Component({
  selector: 'app-empenho-extra-form',
  templateUrl: './empenho-extra-form.component.html',
  styles: [`
    .reinf-isencoes-card { border: 1px solid #dfe5ec; border-radius: 6px; box-shadow: 0 3px 10px rgba(33, 37, 41, 0.06); overflow: hidden; }
    .reinf-isencoes-summary { align-items: center; background: #fbfcfd; display: flex; justify-content: space-between; min-height: 58px; padding: 12px 14px; }
    .reinf-isencoes-title { color: #212529; font-size: 13px; font-weight: 700; line-height: 1.2; }
    .reinf-isencoes-count { color: #6c757d; display: block; font-size: 11px; margin-top: 2px; }
    .reinf-isencoes-open { min-width: 96px; }
    .reinf-isencoes-actions .btn { align-items: center; display: inline-flex; height: 32px; justify-content: center; padding: 0; width: 34px; }
    .reinf-isencoes-modal-toolbar { align-items: center; background: #f8fafc; border-bottom: 1px solid #e5eaf0; color: #495057; display: flex; font-size: 12px; justify-content: space-between; padding: 12px 14px; }
    .reinf-isencoes-empty { color: #6c757d; font-size: 12px; padding: 14px; text-align: center; }
    .reinf-isencoes-table th { background: #fbfcfd; border-top: 0; color: #495057; font-size: 11px; font-weight: 700; text-transform: uppercase; }
    .reinf-isencoes-table td { vertical-align: middle; }
    .reinf-isencoes-type { line-height: 1.25; }
    .reinf-isencoes-code { background: #eef4ff; border: 1px solid #cfe0ff; border-radius: 4px; color: #0d6efd; display: inline-block; font-weight: 700; margin-right: 6px; min-width: 28px; padding: 2px 6px; text-align: center; }
  `]
})
export class EmpenhoExtraFormComponent extends BaseResourceFormComponent<EmpenhoExtra, LoginContabil> implements OnInit, OnDestroy {

  /**
   * Declaração de variáveis
   */
  @ViewChild('tipo_') inputField: ElementRef;

  public favorecidoAutoComplete: EddyAutoComplete<Favorecido>;
  public fichaAutoComplete: EddyAutoComplete<FichaExtra>;
  public contratoAutoComplete: EddyAutoComplete<Contrato>;
  public listaRetencoes: Array<RetencaoExtra>;
  public empenhado: number;
  public pago: number;
  public empenho: EmpenhoExtra;
  public gruposReinf: Array<any> = new Array<any>();
  public grupoReinf: any;
  public objetoReinfTabela1: any;
  public listaIsencoesReinf: EmpenhoExtraIsencaoReinf[] = [];
  public listaDeducoesReinf: EmpenhoExtraDeducaoReinf[] = [];
  private isencaoReinfAntiga: EmpenhoExtraIsencaoReinf;
  private deducaoReinfAntiga: EmpenhoExtraDeducaoReinf;
  public tiposIsencaoReinf = [
    { valor: 1, descricao: 'Parcela isenta de 65 anos.' },
    { valor: 2, descricao: 'Diária de viagem.' },
    { valor: 3, descricao: 'Indenização e rescisão de contrato, inclusive PDV e acidentes de trabalho.' },
    { valor: 4, descricao: 'Abono pecuniário.' },
    { valor: 5, descricao: 'Valores pagos a titular ou sócio de ME/EPP, exceto pró-labore, aluguéis e serviços.' },
    { valor: 6, descricao: 'Pensão, aposentadoria ou reforma por moléstia grave ou acidente em serviço.' },
    { valor: 7, descricao: 'Complementação de aposentadoria de contribuições de 01/01/1989 a 31/12/1995.' },
    { valor: 8, descricao: 'Ajuda de custo.' },
    { valor: 10, descricao: 'Juros de mora por atraso no pagamento de remuneração.' },
    { valor: 11, descricao: 'Resgate de previdência complementar por portador de moléstia grave.' },
    { valor: 12, descricao: 'Lucros e dividendos distribuídos nos termos da Lei nº 9.250/1995.' },
    { valor: 99, descricao: 'Outros (especificar).' },
  ];
  public tiposDeducaoReinf = [
    { valor: 1, descricao: 'Previdência oficial.' },
    { valor: 2, descricao: 'Previdência privada.' },
    { valor: 3, descricao: 'Fundo de aposentadoria programada individual - Fapi.' },
    { valor: 4, descricao: 'Fundação de previdência complementar do servidor público - Funpresp.' },
    { valor: 5, descricao: 'Pensão alimentícia.' },
    { valor: 7, descricao: 'Dependentes.' },
    { valor: 8, descricao: 'Desconto simplificado mensal.' },
  ];


  public imaskNumber2 = {
    mask: Number,
    scale: 2,
    signed: true,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ',',
    mapToRadix: [',', '.']
  };

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    protected globalService: GlobalService,
    protected funcaoService: FuncaoService,
    protected favorecidoService: FavorecidoService,
    protected fichaService: FichaExtraService,
    protected contratoService: ContratoService,
    protected tabela1ReinfService: Tabela1Reinf,
    protected retencaoService: RetencaoExtraService,
    private messageService: MessageService,
    protected confirmationService: ConfirmationService,
    protected assinaturaService: OrgaoAssinaturaService,
    protected empenhoService: EmpenhoExtraService) {
    super(new EmpenhoExtra(), injector, EmpenhoExtra.converteJson, empenhoService);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected async podeAlterar(_entidade: EmpenhoExtra): Promise<boolean> {
    return (_entidade.especie === 'EME' || _entidade.especie === 'SEE') && this.login.sistema != 'indicador-gestao';
  }

  protected criarCamposForm(): void {
    this.entidadeForm = this.fb.group({
      id: [null],
      numero: [null, [Validators.required]],
      data_empenho: [null, [Validators.required]],
      data_vencimento: [null],
      valor_empenho: [0, [Validators.required]],
      valor_rendimento_tributavel: [0],
      mes: [null],
      especie: ['EME'],
      processo: [null],
      documento: [null],
      impresso: [false],
      aux: [0],
      historico: [null, [Validators.required]],
      orgao: [this.login.orgao, [Validators.required]],
      ficha: [null, [Validators.required]],
      favorecido: [null, [Validators.required]],
      contrato: [null],
      exercicio: [this.login.exercicio, [Validators.required]],
      usuario_cadastro: [this.login.usuario],
      retencoes: [null],
      codigo_reinf: [null],
      retencao: [null],
      retencao_resto: [null],
      retencao_extra: [null],
      empenho_antigo: [null],
      isencoes_reinf: [null],
      deducoes_reinf: [null]
    });
  }

  protected parametrosExtras(): {} {
    return { relations: 'ficha,ficha.plano,ficha.recurso,ficha.aplicacao,favorecido,favorecido.tipo,contrato,exercicio,orgao,retencao,retencao.liquidacao,retencao.liquidacao.empenho,retencao_resto,retencao_resto.liquidacao,retencao_resto.liquidacao.empenho,empenho_antigo,isencoes_reinf,deducoes_reinf' };
  }

  protected afterInit(): void {
    this.carregarAutoCompletes();
    this.inicializaVariavel();
    this.carregarTabela1Reinf();
    if (this.currentActionRoute === 'novo') {
      this.empenhoService.proximoNumeroEmpenho(this.login.exercicio.id, this.login.orgao.id)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          this.entidadeForm.get('numero').setValue(res);
          this.empenhoService.ultimaDataEmpenhada(this.login.exercicio.id, this.login.orgao.id)
            .pipe(takeUntil(this.unsubscribe))
            .subscribe((dataEmp) => {
              this.entidade.data_empenho = new DateFormatPipe().transform(dataEmp, []);
              this.entidadeForm.get('data_empenho').setValue(this.entidade.data_empenho);
              this.entidadeForm.get('mes').setValue(this.entidade.data_empenho ? +this.funcaoService.converteDataSQL(this.entidade.data_empenho)?.split('-')?.[1] : 1);
            });
        });
    }
  }

  protected campoFoco(): ElementRef {
    return this.inputField;
  }

  private inicializaVariavel() {
    if (this.currentActionRoute === 'novo') {
      this.listaRetencoes = new Array<RetencaoExtra>();
    }
  }

  private async loadTotalizadores() {
    if (this.entidade.id) {
      this.empenhado = 0;
      this.pago = 0;
      const exercicio: Exercicio = this.entidadeForm.get('exercicio').value
        ? this.entidadeForm.get('exercicio').value
        : this.login.exercicio;
      let totalizadores = await this.empenhoService.totalizadores(
        exercicio.id, this.login.orgao.id, this.entidade.id).toPromise();

      if (totalizadores) {
        totalizadores = totalizadores.content[0] ? totalizadores.content[0] : totalizadores.content;
        this.empenhado = totalizadores.total_empenhado;
        this.pago = totalizadores.total_pago_empenho;
      }
    }
  }

  protected async afterLoad() {
    if (!this.podeAlterarAudesp(this.entidade.data_empenho)) {
      this.router.navigate(['/empenhos-extra']);
      warning('Não é possível alterar. Prazo esgotado!');
      return;
    }
    this.entidade.data_empenho = new DateFormatPipe().transform(this.entidade.data_empenho, []);
    this.entidade.data_vencimento = new DateFormatPipe().transform(this.entidade.data_vencimento, []);
    await this.loadTotalizadores().then(() => {
      this.retencaoService.obterPorLiquidacao(this.entidade.id).pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (data: any) => {
            this.listaRetencoes = data ? data.content : new Array<RetencaoExtra>();
          }, e => this.messageService.add({ severity: 'error', summary: 'Atenção', detail: e })
        );
    });

    this.favorecidoAutoComplete.id = this.entidade.favorecido ? this.entidade.favorecido.id : null;
    this.fichaAutoComplete.id = this.entidade.ficha ? this.entidade.ficha.numero : null;
    this.contratoAutoComplete.id = this.entidade.contrato ? this.entidade.contrato.id : null;
    this.empenho = this.entidade
    this.listaIsencoesReinf = (this.entidade.isencoes_reinf || []).map(item => Object.assign(new EmpenhoExtraIsencaoReinf(), item));
    this.listaDeducoesReinf = (this.entidade.deducoes_reinf || []).map(item => {
      const deducao = Object.assign(new EmpenhoExtraDeducaoReinf(), item);
      deducao.valor_patrocinador = +deducao.valor_patrocinador || 0;
      return deducao;
    });
    this.carregarTabela1Reinf();
    this.atualizarValorRendimentoPorDeducoesReinf();
  }

  protected beforeSubmit() {
    try {
      if (!this.entidadeForm.get('numero').value) {
        throw new Error('Informe o número do empenho');
      }
      if (!this.entidadeForm.get('data_empenho').value) {
        throw new Error('Informe a data do empenho');
      }
      if (!this.entidadeForm.get('especie').value) {
        throw new Error('Informe a espécie do empenho');
      }
      if (!this.entidadeForm.get('valor_empenho').value) {
        throw new Error('Informe o valor do empenho');
      }
      if (!this.entidadeForm.get('exercicio').value) {
        throw new Error('Informe o exercício do empenho');
      }
      if (!this.entidadeForm.get('orgao').value) {
        throw new Error('Informe o órgão do empenho');
      }
      if (!this.entidadeForm.get('favorecido').value) {
        throw new Error('Informe o favorecido do empenho');
      }
      if (!this.entidadeForm.get('ficha').value) {
        throw new Error('Informe a ficha do empenho');
      }
      if (!this.entidadeForm.get('historico').value) {
        throw new Error('Informe o histórico do empenho');
      }
      if (this.entidadeForm.get('valor_empenho').value <= 0) {
        throw new Error('Informe o valor do empenho');
      }
      this.validarDeducoesReinf();
      if (!this.possuiDeducoesReinf() && this.exigeValorRendimentoTributavel() && !+this.entidadeForm.get('valor_rendimento_tributavel').value) {
        throw new Error('Informe o Valor de rendimento tributável para a ficha marcada como Valor tributável');
      }
      if (this.exigeValorRendimentoTributavel() && +this.entidadeForm.get('valor_rendimento_tributavel').value > +this.entidadeForm.get('valor_empenho').value) {
        throw new Error('O Valor de rendimento tributável não pode ser maior que o valor do empenho');
      }
      this.validarIsencoesReinf();
      const dtEmpenho: Date = this.entidadeForm.get('data_empenho').value;
      if (dtEmpenho > new Date()) {
        throw new Error('Data do empenho está maior que a data atual');
      }
      if (dtEmpenho.getFullYear() !== this.login.exercicio.ano) {
        throw new Error('O ano da data do empenho está diferente do exercício logado');
      }
      this.entidadeForm.get('mes').setValue(+this.funcaoService.converteDataSQL(this.entidadeForm.get('data_empenho').value)?.split('-')?.[1]);
      let retencaoEditando = this.listaRetencoes.find(e => e.editavel);
      if (retencaoEditando) {
        throw new Error('Acabe de editar as retenções');
      }
      this.entidadeForm.get('retencoes').setValue(this.listaRetencoes);
      this.entidadeForm.get('isencoes_reinf').setValue(this.isencoesReinfParaSalvar());
      this.entidadeForm.get('deducoes_reinf').setValue(this.deducoesReinfParaSalvar());
      const ficha: FichaExtra = this.entidadeForm.get('ficha').value;
      if (
        ['2188101', '2188201', '2188301', '2188401', '2188501'].includes(ficha.plano.codigo.substring(0, 7)) &&
        (!this.entidadeForm.get('retencao').value && !this.entidadeForm.get('retencao_resto').value && !this.entidadeForm.get('retencao_extra').value)
      ) {
        throw new Error('Classificação da ficha extra não permite empenho extra sem origem');
      }

      if (!this.funcaoService.podeAlterarAudesp(this.entidadeForm.get('data_empenho').value, this.login)) {
        throw new Error('O mês do registro já foi armazenado no TCE. Não é possível salvar!');
      }
    } catch (e) {
      this.funcaoService.acaoErro(e);
      throw e;
    }
  }

  protected afterSubmit(ent: EmpenhoExtra) {
    this.mensagemSucesso = `Registro salvo com sucesso!\nEmpenho Extra nº ${ent.numero}`;
    this.listaRetencoes = new Array<RetencaoExtra>();
    if (this.currentActionRoute === 'novo') {
      this.router.navigate(['/empenhos-extra', 'novo']);
    } else if (this.currentActionRoute === 'editar') {
      this.router.navigate(['/empenhos-extra', ent.id, 'editar'], { skipLocationChange: true }).then(() => {
        this.loadResource();
      });
    }
  }

  public verificarEmpenhoVinculado() {
    if (this.entidade.retencao || this.entidade.retencao_resto) {
      return 'disabled';
    } else {
      return null;
    }
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================


  public obterValorEmpenho() {
    const valorEmpenho = this.entidadeForm.get('valor_empenho').value;
    this.entidade.valor_empenho = +valorEmpenho
    this.atualizarValorRendimentoPorDeducoesReinf();
  }

  public exigeValorRendimentoTributavel(): boolean {
    const ficha: FichaExtra = this.entidadeForm?.get('ficha')?.value || this.entidade?.ficha;
    return !!ficha?.valor_tributavel;
  }

  public permiteIsencoesReinf(): boolean {
    const ficha: FichaExtra = this.entidadeForm?.get('ficha')?.value || this.entidade?.ficha;
    return !!ficha?.isencoes_reinf;
  }

  public permiteDeducoesReinf(): boolean {
    const ficha: FichaExtra = this.entidadeForm?.get('ficha')?.value || this.entidade?.ficha;
    return !!ficha?.deducoes_reinf && this.favorecidoPessoaFisica();
  }

  public favorecidoPessoaFisica(): boolean {
    const favorecido: Favorecido = this.entidadeForm?.get('favorecido')?.value || this.entidade?.favorecido;
    return favorecido?.tipo?.nome === 'CPF - PESSOA FÍSICA' || favorecido?.tipo?.tce === '02';
  }

  public possuiDeducoesReinf(): boolean {
    return this.totalDeducoesReinf() > 0;
  }

  public possuiCalculoIr(): boolean {
    return this.listaRetencoes?.some((retencao) => {
      return +retencao.base_IR > 0
        || +retencao.valor_IR > 0
        || retencao.ficha?.ir_reinf_4000
        || retencao.ficha?.ficha?.tipo_imposto === 'IR'
        || retencao.ficha?.['tipo_imposto'] === 'IR';
    });
  }

  public bloqueiaDeducoesReinf(): boolean {
    return this.possuiCalculoIr();
  }

  public bloqueiaValorRendimentoTributavel(): boolean {
    return this.possuiDeducoesReinf();
  }

  public atualizarValorRendimentoPorDeducoesReinf(): void {
    if (!this.possuiDeducoesReinf()) {
      return;
    }
    this.entidadeForm.get('valor_rendimento_tributavel').setValue(`${this.valorRendimentoPorDeducoesReinf()}`);
  }

  private valorRendimentoPorDeducoesReinf(): number {
    const valorEmpenho = +this.entidadeForm.get('valor_empenho').value || 0;
    const valorBaseIr = +(valorEmpenho - this.totalDeducoesReinf()).toFixed(2);
    return valorBaseIr >= 0 ? valorBaseIr : 0;
  }

  public adicionarIsencaoReinf() {
    if (this.listaIsencoesReinf.some(item => item['editavel'])) {
      toastr.warning('Já existe uma isenção em edição, salve ou cancele para adicionar outra.');
      return;
    }

    const isencao = new EmpenhoExtraIsencaoReinf();
    isencao['editavel'] = true;
    this.listaIsencoesReinf.push(isencao);
  }

  public abrirIsencoesReinf() {
    $('#dlgIsencoesReinf').modal('show');
  }

  public editarIsencaoReinf(isencao: EmpenhoExtraIsencaoReinf) {
    if (this.listaIsencoesReinf.some(item => item['editavel'])) {
      toastr.warning('Já existe uma isenção em edição, salve ou cancele para editar outra.');
      return;
    }

    this.isencaoReinfAntiga = Object.assign(new EmpenhoExtraIsencaoReinf(), isencao);
    isencao['editavel'] = true;
  }

  public salvarIsencaoReinf(isencao: EmpenhoExtraIsencaoReinf) {
    try {
      this.validarIsencaoReinf(isencao);
      isencao['editavel'] = false;
      this.isencaoReinfAntiga = null;
    } catch (e) {
      this.funcaoService.acaoErro(e);
    }
  }

  public cancelarIsencaoReinf(isencao: EmpenhoExtraIsencaoReinf, index: number) {
    if (isencao.id && this.isencaoReinfAntiga) {
      this.listaIsencoesReinf.splice(index, 1, Object.assign(new EmpenhoExtraIsencaoReinf(), this.isencaoReinfAntiga));
    } else {
      this.listaIsencoesReinf.splice(index, 1);
    }

    this.isencaoReinfAntiga = null;
  }

  public removerIsencaoReinf(index: number) {
    this.listaIsencoesReinf.splice(index, 1);
  }

  public alterarTipoIsencaoReinf(isencao: EmpenhoExtraIsencaoReinf) {
    if (+isencao.tipo !== 6) {
      isencao.data_laudo = null;
    }
  }

  public tipoIsencaoReinfPermitido(tipo: number): boolean {
    if (!this.objetoReinfTabela1?.insencao) {
      return false;
    }

    return this.objetoReinfTabela1.insencao.split(';').map((item: string) => +item).includes(+tipo);
  }

  public tiposIsencaoReinfPermitidos() {
    return this.tiposIsencaoReinf.filter(tipo => this.tipoIsencaoReinfPermitido(tipo.valor));
  }

  public descricaoTipoIsencaoReinf(tipo: number): string {
    return this.tiposIsencaoReinf.find(item => item.valor === +tipo)?.descricao || '';
  }

  private validarIsencoesReinf() {
    if (!this.permiteIsencoesReinf()) {
      this.listaIsencoesReinf = [];
      return;
    }

    if (this.listaIsencoesReinf.some(item => item['editavel'])) {
      throw new Error('Salve ou cancele a isenção em edição antes de salvar o empenho.');
    }

    this.listaIsencoesReinf.forEach(item => this.validarIsencaoReinf(item));

    const totalIsencoes = this.listaIsencoesReinf.reduce((total, item) => total + (+item.valor_isento || 0), 0);
    if (+totalIsencoes.toFixed(2) > +(+this.entidadeForm.get('valor_empenho').value).toFixed(2)) {
      throw new Error('O total das isenções não pode ser maior que o valor do empenho.');
    }
  }

  private validarIsencaoReinf(isencao: EmpenhoExtraIsencaoReinf) {
    const tipo = +isencao.tipo;
    const valor = +isencao.valor_isento;

    if (!tipo) {
      throw new Error('Informe o tipo da isenção da EFD-Reinf.');
    }

    if (!valor || valor <= 0) {
      throw new Error('Informe o valor da isenção da EFD-Reinf.');
    }

    if (valor > +this.entidadeForm.get('valor_empenho').value) {
      throw new Error('O valor da isenção não pode ser maior que o valor do empenho.');
    }

    if (!this.tipoIsencaoReinfPermitido(tipo)) {
      throw new Error('Tipo de isenção não permitido para a Natureza de Rendimento da Reinf.');
    }

    if (tipo == 99) {
      if (!isencao.descricao?.trim()) throw new Error('Descrição/especificação da isenção obrigatória para o tipo 99 - Outros.');

      const descTrimmed = isencao.descricao.trim();
      // Mínimo de 5 caracteres alfabéticos
      const alfabeticos = (descTrimmed.match(/[a-zA-ZÀ-ÿ]/g) || []).length;
      if (alfabeticos < 5) {
        throw new Error(`Descrição dos rendimentos isentos deve conter no mínimo 5 caracteres alfabéticos!`);
      }
      // Sem repetição consecutiva de caracteres especiais
      if (/([^a-zA-ZÀ-ÿ0-9\s])\1+/.test(descTrimmed)) {
        throw new Error(`Descrição dos rendimentos isentos não pode conter repetição consecutiva de caracteres especiais!`);
      }

    } else if (tipo != 99 && (isencao.descricao && isencao.descricao.trim() != '')) {
      throw new Error('Descrição/especificação da isenção só pode ser informado para o tipo 99 - Outros.');
    }



    if (tipo === 6 && !this.dataLaudoIsencaoValida(isencao.data_laudo)) {
      throw new Error('Informe a Data da moléstia grave no laudo válida para isenção do tipo 6.');
    }

    if (tipo !== 6) {
      isencao.data_laudo = null;
    }
  }

  private dataLaudoIsencaoValida(data: string): boolean {
    if (!data || data.indexOf('_') >= 0) {
      return false;
    }

    const partes = data.split('/');
    if (partes.length !== 3) {
      return false;
    }

    const dia = +partes[0];
    const mes = +partes[1];
    const ano = +partes[2];
    const dataObj = new Date(ano, mes - 1, dia);

    return ano >= 1900
      && dataObj.getFullYear() === ano
      && dataObj.getMonth() === mes - 1
      && dataObj.getDate() === dia;
  }

  private isencoesReinfParaSalvar(): EmpenhoExtraIsencaoReinf[] {
    return this.listaIsencoesReinf.map(item => {
      const isencao = Object.assign(new EmpenhoExtraIsencaoReinf(), item);
      delete isencao['editavel'];
      return isencao;
    });
  }

  public adicionarDeducaoReinf() {
    if (this.bloqueiaDeducoesReinf()) {
      toastr.warning('Não é possível alterar deduções Reinf após o cálculo do IR.');
      return;
    }
    if (this.listaDeducoesReinf.some(item => item['editavel'])) {
      toastr.warning('Já existe uma dedução em edição, salve ou cancele para adicionar outra.');
      return;
    }

    const deducao = new EmpenhoExtraDeducaoReinf();
    deducao.previdencia_complementar = false;
    deducao.valor_patrocinador = 0;
    deducao['editavel'] = true;
    this.listaDeducoesReinf.push(deducao);
  }

  public abrirDeducoesReinf() {
    $('#dlgDeducoesReinf').modal('show');
  }

  public editarDeducaoReinf(deducao: EmpenhoExtraDeducaoReinf) {
    if (this.bloqueiaDeducoesReinf()) {
      toastr.warning('Não é possível alterar deduções Reinf após o cálculo do IR.');
      return;
    }
    if (this.listaDeducoesReinf.some(item => item['editavel'])) {
      toastr.warning('Já existe uma dedução em edição, salve ou cancele para editar outra.');
      return;
    }

    this.deducaoReinfAntiga = Object.assign(new EmpenhoExtraDeducaoReinf(), deducao);
    deducao.valor_patrocinador = +deducao.valor_patrocinador || 0;
    deducao['editavel'] = true;
  }

  public salvarDeducaoReinf(deducao: EmpenhoExtraDeducaoReinf) {
    try {
      this.validarDeducaoReinf(deducao);
      deducao['editavel'] = false;
      this.deducaoReinfAntiga = null;
      this.atualizarValorRendimentoPorDeducoesReinf();
    } catch (e) {
      this.funcaoService.acaoErro(e);
    }
  }

  public cancelarDeducaoReinf(deducao: EmpenhoExtraDeducaoReinf, index: number) {
    if (deducao.id && this.deducaoReinfAntiga) {
      this.listaDeducoesReinf.splice(index, 1, Object.assign(new EmpenhoExtraDeducaoReinf(), this.deducaoReinfAntiga));
    } else {
      this.listaDeducoesReinf.splice(index, 1);
    }

    this.deducaoReinfAntiga = null;
    this.atualizarValorRendimentoPorDeducoesReinf();
  }

  public removerDeducaoReinf(index: number) {
    if (this.bloqueiaDeducoesReinf()) {
      toastr.warning('Não é possível alterar deduções Reinf após o cálculo do IR.');
      return;
    }
    this.listaDeducoesReinf.splice(index, 1);
    this.atualizarValorRendimentoPorDeducoesReinf();
  }

  public alterarTipoDeducaoReinf(deducao: EmpenhoExtraDeducaoReinf) {
    if (![2, 3, 4].includes(+deducao.tipo)) {
      deducao.previdencia_complementar = false;
      deducao.cnpj_previdencia_complementar = null;
    }
    if (+deducao.tipo !== 4) {
      deducao.valor_patrocinador = 0;
    }
  }

  public tipoDeducaoReinfPermitido(tipo: number): boolean {
    if (!this.objetoReinfTabela1?.ded) {
      return false;
    }

    return this.objetoReinfTabela1.ded.split(';').map((item: string) => +item).includes(+tipo);
  }

  public tiposDeducaoReinfPermitidos() {
    return this.tiposDeducaoReinf.filter(tipo => this.tipoDeducaoReinfPermitido(tipo.valor));
  }

  public descricaoTipoDeducaoReinf(tipo: number): string {
    return this.tiposDeducaoReinf.find(item => item.valor === +tipo)?.descricao || '';
  }

  public totalDeducoesReinf(): number {
    return +(this.listaDeducoesReinf || []).reduce((total, item) => total + (+item.valor_deducao || 0), 0).toFixed(2);
  }

  private validarDeducoesReinf() {
    if (!this.permiteDeducoesReinf()) {
      this.listaDeducoesReinf = [];
      return;
    }

    if (this.listaDeducoesReinf.some(item => item['editavel'])) {
      throw new Error('Salve ou cancele a dedução em edição antes de salvar o empenho.');
    }

    this.listaDeducoesReinf.forEach(item => this.validarDeducaoReinf(item));
    this.validarCnpjPrevidenciaComplementarDuplicado();

    const totalDeducoes = this.totalDeducoesReinf();
    if (+totalDeducoes.toFixed(2) > +(+this.entidadeForm.get('valor_empenho').value).toFixed(2)) {
      throw new Error('O total das deduções não pode ser maior que o valor do empenho.');
    }

    this.atualizarValorRendimentoPorDeducoesReinf();
  }

  private validarDeducaoReinf(deducao: EmpenhoExtraDeducaoReinf) {
    const tipo = +deducao.tipo;
    const valor = +deducao.valor_deducao;

    if (!tipo) {
      throw new Error('Informe o tipo da dedução da EFD-Reinf.');
    }

    if (!valor || valor <= 0) {
      throw new Error('Informe o valor da dedução da EFD-Reinf.');
    }

    if (valor > +this.entidadeForm.get('valor_empenho').value) {
      throw new Error('O valor da dedução não pode ser maior que o valor do empenho.');
    }

    if (!this.tipoDeducaoReinfPermitido(tipo)) {
      throw new Error('Tipo de dedução não permitido para a Natureza de Rendimento da Reinf.');
    }

    if ([2, 3, 4].includes(tipo) && deducao.previdencia_complementar && !this.cnpjPrevidenciaValido(deducao.cnpj_previdencia_complementar)) {
      throw new Error('Informe um CNPJ válido para a entidade de previdência complementar.');
    }

    deducao.valor_patrocinador = +deducao.valor_patrocinador || 0;
    this.alterarTipoDeducaoReinf(deducao);
  }

  private validarCnpjPrevidenciaComplementarDuplicado(): void {
    const chaves = new Set<string>();
    for (const deducao of this.listaDeducoesReinf) {
      if (!deducao.previdencia_complementar || ![2, 3, 4].includes(+deducao.tipo)) {
        continue;
      }
      const cnpj = String(deducao.cnpj_previdencia_complementar || '').replace(/\D/g, '');
      const chave = `${deducao.tipo}-${cnpj}`;
      if (chaves.has(chave)) {
        throw new Error('O CNPJ da previdência complementar não pode ser repetido para o mesmo tipo de dedução.');
      }
      chaves.add(chave);
    }
  }

  private cnpjPrevidenciaValido(cnpj: string): boolean {
    const valor = String(cnpj || '').replace(/\D/g, '');
    return valor.length === 14 && !/^(\d)\1+$/.test(valor);
  }

  private deducoesReinfParaSalvar(): EmpenhoExtraDeducaoReinf[] {
    return this.listaDeducoesReinf.map(item => {
      const deducao = Object.assign(new EmpenhoExtraDeducaoReinf(), item);
      deducao.valor_patrocinador = +deducao.valor_patrocinador || 0;
      delete deducao['editavel'];
      return deducao;
    });
  }

  private carregarAutoCompletes() {
    // autocomplete para favorecido
    this.favorecidoAutoComplete = new EddyAutoComplete(this.entidadeForm.get('favorecido'), this.favorecidoService,
      'id', ['nome'], { cidade_id: this.login.cidade.id, orderBy: 'nome' }, { number: ['id', 'cpf_cnpj'], text: ['nome'] }
    );

    // autocomplete para ficha
    this.fichaAutoComplete = new EddyAutoComplete(this.entidadeForm.get('ficha'), this.fichaService,
      'numero', ['numero', 'nome'],
      { exercicio_id: this.login.exercicio.id, excluida: false, orgao_id: this.login.orgao.id, relations: 'favorecido,favorecido.tipo,plano,recurso,aplicacao', orderBy: 'nome' },
      { number: ['numero'], text: ['nome'] },
      () => {
        this.entidadeForm.get('favorecido').setValue(this.entidadeForm.get('ficha').value.favorecido);
        this.favorecidoAutoComplete.id = this.entidadeForm.get('ficha').value.favorecido.id;
        this.entidade.codigo_reinf = this.entidadeForm.get('ficha').value.codigo_reinf;
        this.entidadeForm.get('codigo_reinf').setValue(this.entidadeForm.get('ficha').value.codigo_reinf);
        this.carregarTabela1Reinf();
        if (!this.permiteIsencoesReinf()) {
          this.listaIsencoesReinf = [];
        }
        if (!this.permiteDeducoesReinf()) {
          this.listaDeducoesReinf = [];
        }
        this.atualizarValorRendimentoPorDeducoesReinf();
      }
    );

    // autocomplete para contrato
    this.contratoAutoComplete = new EddyAutoComplete(this.entidadeForm.get('contrato'), this.contratoService,
      'numero', ['numero'], { orgao_id: this.login.orgao.id, orderBy: 'numero' }, { number: ['id', 'numero'] }
    );
  }

  public voltar() {
    switch (this.login.sistema) {
      case 'contabil':
      case 'controle-interno':
        this.router.navigate(['/contabilidade']);
        break;
      default:
        this.sair();
        break;
    }
  }

  public imprimir() {
    const parametros = {};
    let relations = 'contrato.licitacao.modalidade,ficha.aplicacao,ficha.recurso,ficha.aplicacao_variavel,contrato,favorecido.contas.banco,convenio,retencao.liquidacao.empenho.favorecido';
    parametros['relations'] = relations;
    parametros['exercicio_id'] = this.login.exercicio.id;
    parametros['orgao_id'] = this.login.orgao.id;
    parametros['id'] = this.entidade.id;

    this.empenhoService
      .extendido(1, -1, parametros)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(lista => {
        new NotaEmpenhoExtra(this.assinaturaService).imprimir(lista.content, this.login);
      },
        (e) => this.messageService.add(
          { severity: 'error', summary: 'Atenção!', detail: e.error && e.error.payload ? e.error.payload : e }
        )
      );
  }

  public temRetencoes(): boolean {
    return !!!(this.entidade.retencao?.id || this.entidade.retencao_resto?.id)
  }

  public carregarTabela1Reinf() {
    if (this.grupoReinf == null) {
      this.gruposReinf = this.tabela1ReinfService.carregarTabela1();
    }
    if (this.entidade?.codigo_reinf) {
      this.grupoReinf = this.tabela1ReinfService.carregarPorCodigo(this.entidade.codigo_reinf, false);
      for (let i = 0; i < this.gruposReinf.length; i++) {
        if (this.gruposReinf[i].codigo == this.grupoReinf.codigo) {
          this.gruposReinf[i] = this.grupoReinf;
          break;
        }
      }
    }

    const codigoReinf = this.entidadeForm?.get('codigo_reinf')?.value || this.entidade?.codigo_reinf;
    this.objetoReinfTabela1 = codigoReinf
      ? this.tabela1ReinfService.carregarPorCodigo(codigoReinf, true)
      : null;
  }

  public salvarCodigoReinf() {
    this.entidade.codigo_reinf = this.entidadeForm.get('codigo_reinf').value;
    this.carregarTabela1Reinf();
  }
}
